export default {
  MarkAttendance: 'MA',
  ProgressTest: 'PT',
  ProgressReport: 'PR',
  MarkHomework: 'MH',
  AssignHomework: 'AH',
  GroupDashboard: 'GD',
  CoveredInClass: 'CIC',
  CoveredInClassRAv2: 'CIC_RAv2',
  CoveredInClassAndHomeworkHFv4: 'CIC_HFv4',
  DigitalPracticeRAv2: 'MH_RAv2',
  IDP: 'IDP',
  UnitReview: 'URW',
  UnlockHomework: 'AH-UN',
  Assignments: 'AH-AS',
  SmallStarsApp: 'MH-SA',
  UnitQuiz: 'MH-UQ',
  Reader: 'MH-RD',
  Vocabulary: 'MH-VY',
  PracticePlay: 'MH-PP',
  PaperBased: 'MH-PB',
  TrailblazersApp: 'MH-ETA',
  Mentor: 'MH-ME',
  Online: 'MH-OL',
  OnlineUsage: 'MH-OU',
  GrammaPro: 'GP',
  WritingAssignment: 'WA',
  SessionReport: 'SR',
  MidtermAndFinalExam: 'MFE',
  AssessmentHFv4: 'MFE_HFv4',
  UnitReportHFv4: 'UR_HFv4',
  ProgressReportHFv4: 'PR_HFv4',
  KETMockExam: 'KET_MOCK',
  KETScore: 'KET_SCORE',
};



// WEBPACK FOOTER //
// ./domain/TabSwitcher/TabCodes/index.js